export const iconFontAwesomeHumanitarianPersonCircleCheck = (
	<i className="fa-solid fa-person-circle-check"></i>
);
